import { registerEntityEndpoint as e } from "@editor/ui-utils";
//#region \0plugin-vue:export-helper
var t = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, n = e("links-box"), { getEntity: r, listEntities: i, putEntity: a, postEntity: o, deleteEntity: s } = n, c = async (e) => r(e), l = async (e) => o(e), u = async (e, t) => a(t, e), d = async (e) => s(e), f = async (e) => i({ params: { ...e.length ? { uuid: e } : {} } }), p = (e) => {
	let { _id: t, createDate: n, changeDate: r, isDeleted: i, ...a } = e;
	return a;
};
//#endregion
export { c as a, t as c, f as i, d as n, l as o, p as r, u as s, n as t };

//# sourceMappingURL=links-box.service-CGql-tfK.js.map